import config, { version } from "../config";
import { updateStorage } from "./storage-utils";
var listeners = [];
export var DEBUG_KEY = "lapel-debugger";
export var ENV_KEY = DEBUG_KEY.toUpperCase().replace(/-/g, "_");
var setupStorageListener = function() {
    if (typeof window === "undefined") {
        return;
    }
    var listener = function(event) {
        var key = event.key, newValue = event.newValue, oldValue = event.oldValue;
        if (key === DEBUG_KEY && newValue !== oldValue) {
            var debugLevel = parseDebugValue(newValue);
            listeners.forEach(function(callback) {
                callback(debugLevel);
            });
        }
    };
    window.addEventListener("storage", listener);
    return function() {
        window.removeEventListener("storage", listener);
    };
};
var parseDebugValue = function(value1) {
    if (typeof value1 === "string") {
        if (value1 === "true") {
            return true;
        }
        if (value1 === "false") {
            return false;
        }
        return value1.toLowerCase();
    }
    return value1;
};
var getENVDebugLevel = function() {
    var _process_env, _process;
    var _$value = (_process = process) == null ? void 0 : (_process_env = _process.env) == null ? void 0 : _process_env[ENV_KEY];
    if (_$value) {
        return parseDebugValue(_$value);
    }
    return null;
};
export var getGlobalLapel = function() {
    return typeof window !== "undefined" ? window["Lapel(v" + version + ")"] : {};
};
export var getDebugLevel = function() {
    try {
        var _window_location, _window, _urlParams;
        if (typeof window === "undefined") {
            // server side
            return getENVDebugLevel();
        }
        var urlParams = new URLSearchParams((_window = window) == null ? void 0 : (_window_location = _window.location) == null ? void 0 : _window_location.search);
        var urlValue = (_urlParams = urlParams) == null ? void 0 : _urlParams.get(DEBUG_KEY);
        if (urlValue) {
            var parsedValue = parseDebugValue(urlValue);
            updateStorage(sessionStorage, DEBUG_KEY, parsedValue);
            return parsedValue;
        } else if (sessionStorage.hasOwnProperty(DEBUG_KEY)) {
            var storageValue = sessionStorage.getItem(DEBUG_KEY);
            if (storageValue) {
                return parseDebugValue(storageValue);
            }
        }
        return null;
    } catch (err) {
        return null;
    }
};
export var setDebugLevel = function(value1) {
    updateStorage(sessionStorage, DEBUG_KEY, value1);
};
export var isDebugging = function() {
    return Boolean(getDebugLevel());
};
export var whenDebugging = function(callback) {
    callback(getDebugLevel());
    listeners.push(callback);
    return function() {
        var index = listeners.indexOf(callback);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
};
if (typeof window !== "undefined") {
    if (window.Lapel) {
        console.error("Lapel(v" + window.Lapel.version + ") already defined!");
    }
    window.Lapel = {
        version: version,
        config: config,
        get debugLevel () {
            return getDebugLevel();
        },
        set debugLevel (value){
            setDebugLevel(value);
        },
        whenDebugging: whenDebugging
    };
    window["Lapel(v" + version + ")"] = window.Lapel;
    setupStorageListener();
}

//# sourceMappingURL=debug.js.map